export default "__VITE_ASSET__BERiKRGu__"